import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { BRAND_ASSETS } from 'src/app/core/constants/brand-assets';
import { AuthThemeDirective } from 'src/app/core/directives/auth-theme-directive';

@Component({
  selector: 'app-reset-options',
  imports: [CommonModule, AuthThemeDirective, RouterLink],
  templateUrl: './reset-options.component.html',
  styleUrl: './reset-options.component.scss',
})
export class ResetOptionsComponent {
  readonly logo = BRAND_ASSETS.logoShieldOnDark;
  constructor(
    private router: Router
  ){}

  
  goTo(path: string): void{
    this.router.navigate([`/forgot-password/${path}`]);
  }

}
